// extracted by mini-css-extract-plugin
module.exports = {"pill":"styles_pill___Rd9G","dot":"styles_dot__wZeHH","caraBlink":"styles_caraBlink__VNkmO"};